import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

// Legacy fallback: sessions created before the httpOnly-cookie migration still
// carry a localStorage token. New logins never write it (cookie only).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pc_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('pc_token');
      localStorage.removeItem('pc_user');
    }
    return Promise.reject(err);
  }
);

export const fileURL = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
};

/**
 * Build a photo URL suitable for <img src>. The httpOnly session cookie is sent
 * automatically by the browser (same-origin). Legacy pre-cookie sessions still
 * append ?auth={token} since <img> tags cannot send Authorization headers.
 */
export const photoURL = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  const abs = `${BACKEND_URL}${path}`;
  if (path.startsWith('/api/photos/')) {
    const token = localStorage.getItem('pc_token');
    if (token) {
      const sep = path.includes('?') ? '&' : '?';
      return `${abs}${sep}auth=${encodeURIComponent(token)}`;
    }
  }
  return abs;
};
